var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.4C0.668629 3.4 0.4 3.66863 0.4 4C0.4 4.33137 0.668629 4.6 1 4.6V3.4ZM11 4.6C11.3314 4.6 11.6 4.33137 11.6 4C11.6 3.66863 11.3314 3.4 11 3.4V4.6ZM1 4.6H11V3.4H1V4.6Z",
    fill: "#001636",
    fillOpacity: 0.92
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.4C0.668629 9.4 0.4 9.66863 0.4 10C0.4 10.3314 0.668629 10.6 1 10.6V9.4ZM19 10.6C19.3314 10.6 19.6 10.3314 19.6 10C19.6 9.66863 19.3314 9.4 19 9.4V10.6ZM1 10.6H19V9.4H1V10.6Z",
    fill: "#001636",
    fillOpacity: 0.92
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99512 15.4C8.66375 15.4 8.39512 15.6686 8.39512 16C8.39512 16.3314 8.66375 16.6 8.99512 16.6V15.4ZM18.9951 16.6C19.3265 16.6 19.5951 16.3314 19.5951 16C19.5951 15.6686 19.3265 15.4 18.9951 15.4V16.6ZM8.99512 16.6H18.9951V15.4H8.99512V16.6Z",
    fill: "#001636",
    fillOpacity: 0.92
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/Hamburger.466774282410e6e67e04797354e39dab.svg";
export { ForwardRef as ReactComponent };